<template>
  <v-container fluid ma-0 pa-0>
    <v-layout wrap>
      <v-flex xs12>
        <h5>{{ label }}</h5>
      </v-flex>
      <v-flex xs12>
        <v-list>
          <v-list-tile v-for="(file, index) in value" :key="index + ':' + file.id" avatar @click="previewFile(index)">
            <v-list-tile-avatar>
              <v-icon class="grey lighten-1 white--text">attach_file</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ file.name }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <v-progress-linear v-if="file.progress && file.progress < 100" v-model="file.progress" />
                <span v-if="file.error" class="red--text">{{ file.error }}</span>
                {{ file.size | humanizeSize }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="!readonly">
              <v-btn icon ripple @click.stop="delFile(index)">
                <v-icon color="red lighten-1">delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-dialog v-model="preview" lazy max-width="1300">
          <v-card>
            <v-card-text>
              <!-- <iframe :src="'https://view.officeapps.live.com/op/embed.aspx?src='+previewSrc" width='1260px' height='623px' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe> -->
              <iframe v-if="previewSrc" :src="'https://docs.google.com/gview?url='+previewSrc+'&embedded=true'"></iframe>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" flat @click="preview = false">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex v-if="!readonly" xs12 text-xs-right>
        <input type="file" multiple style="display: none;" ref="file" @change="onFilePicked" accept="application/pdf,image/*,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
        <v-btn color="primary" small @click="addFile">
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <!-- <input type="file" accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" /> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DefaultField from './default'
import { humanizeSize } from '@/plugins/helpers'

export default {
  mixins: [DefaultField],
  filters: {
    humanizeSize,
  },
  props: {
    model: {
      type: Array,
      default: () => [],
    },
    indicatorValue: {
      type: Object,
      required: false
    },
    indicatorField: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    value: [],
    preview: false,
    previewSrc: '',
  }),
  mounted () {
    this.normalize()
  },
  methods: {
    normalize () {
      let norm = this.value || []
      norm.forEach((file) => {
        if (!file.url && file.id) {
          this.$store.dispatch('indicators/getDocumentURL', file).then((url) => {
            file.url = url
            this.previewSrc = file.url
          })
        }
      })
      this.value = norm
    },
    previewFile (index) {
      let file = this.value[index]
      if (!file) {
        return
      }
      if (file.error) {
        return
      }

      if (file.id) {
        this.previewSrc = file.url
        let win = window.open(this.previewSrc, '_blank')
      }
    },
    addFile () {
      this.$refs.file.click()
    },
    uploadFilesProgress (index, progress) {
      this.value[index].progress = progress * 100
    },
    delFile (index) {
      let file = this.value[index]
      if (!file) {
        return
      }
      if (file.error) {
        this.value.splice(index, 1)
        return
      }
      this.$events.$emit('confirm', {
        message: `Вы действительно хотите удалить файл<br><b>"${file.name}"</b>?`,
        action: () => {
          if (file._f) {
            // еще не загружено, просто удаляем из списка
            this.value.splice(index, 1)
            this.sync()
          } else {
            // файл загружен, нужно удалять на сервере
            this.$store.dispatch('indicators/deleteDocument', file).then(() => {
              this.value.splice(index, 1)
              this.sync()
            })
          }
        }
      })
    },
    onFilePicked (e) {
      const files = e.target.files
      const count = this.value.length

      Array.from(files).forEach((file, index) => {
        let item = {
          id: '',
          name: file.name,
          size: file.size,
          mime: file.type,
          progress: 0,
          url: '',
          error: '',
          _f: file,
        }

        this.$store.dispatch('indicators/uploadDocument', { file, indicatorValue: this.indicatorValue, indicatorField: this.indicatorField, progress: (event) => {
          this.uploadFilesProgress(count + index, event.loaded / event.total)
        }}).then((document) => {
          item.id = document.id
          item.url = document.url
          this.sync()
        }).catch((error) => {
          item.progress = 0
          item.error = error.message
        })

        this.value.push(item)
      })

      e.target.value = null
    },
  }
}
</script>
